import { Component, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Product } from '../../../../shared/models/product.model';
import { ProductAutocompleteComponent } from '../../autocomplete/product/product-autocomplete.component';

@Component({
  standalone: false,
  selector: 'app-additional-product',
  templateUrl: './additional-product.component.html',
  styleUrls: ['../modal.component.scss']
})

export class AdditionalProductComponent implements OnInit {
  articleForm: FormGroup;
  @Output() readonly responseChanged = new EventEmitter();
  @ViewChild(ProductAutocompleteComponent, { static: false }) productAutocomplete: ProductAutocompleteComponent;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.articleForm = this.fb.group({
      articleId: ['', Validators.required],
      quantity: [null, Validators.required]
    });
  }

  onSelectProduct(product: Product): void {
    this.f.articleId.setValue(product.productId);
    this.productAutocomplete.searchTerm = product.name;
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }

  emitTrue(): void {
    this.responseChanged.emit(this.articleForm.value);
  }

  get f() {
    return this.articleForm.controls;
  }
}